export default {
  'statementGrid.accountName': 'Account Name',
  'statementGrid.accountNumber': 'Account Number',
  'statementGrid.currencyCode': 'Currency Code',
  'statementGrid.statementPeriod': 'Statement Period',
  'statementGrid.description': 'Description',
  'statementGrid.requestNotFound': 'Request not found',
  'statementGrid.notAvailable': 'Not Available',
  'statementGrid.statementType': 'Statement Type'
};
